/* 🤖 this file was generated by svg-to-ts */
export const fthrChevronDown: {
    name: 'fthr-chevron-down';
    data: string;
} = {
    name: 'fthr-chevron-down',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-chevron-down" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg>`,
};
